import { ThresholdData } from '@cmps/ng-kit';

import { bgGradient } from '../../common/pipe/bg-gradient';
import { CardPerformanceDataContainer as MetricItem } from '../../insight/models/card-performance-data-container.model';
import { ThresholdBand } from '../../insight/performance-data/threshold-band.model';

export function getThresholdData(input: MetricItem): ThresholdData[] {
    const thresholds: ThresholdData[] = [];
    const config = input.thresholdBands;
    if (config == null || input.target == null || input.target === 0)
        return thresholds;
    let endValue: number;
    let minValue = input.minValueMetric;
    const isHigherToLow = input.minValueMetric > input.maxValueMetric;

    const addThreshold = (
        color: string,
        startValue: number,
        endValue: number,
    ): void => {
        const enabled = !isHigherToLow
            ? (input.actual >= startValue && input.actual <= endValue) ||
              (endValue === input.maxValueMetric &&
                  input.actual > input.maxValueMetric)
            : input.actual <= startValue && input.actual >= endValue;
        thresholds.push({
            color,
            colorGradient: bgGradient({ color }),
            startValue,
            endValue,
            enabled,
        });
    };

    // Handle negative thresholds
    const negBands = [
        ThresholdBand.NEG3,
        ThresholdBand.NEG2,
        ThresholdBand.NEG1,
    ];
    negBands.forEach((bandId) => {
        const bandConfig = config.find(
            (band) => band.thresholdBandId === bandId,
        );
        if (bandConfig != null) {
            const adjustmentFactor = isHigherToLow ? -100 : 100;
            endValue =
                (1 - (bandConfig.value ?? 0) / adjustmentFactor) * input.target;
            addThreshold(bandConfig.colour, minValue, endValue);
            minValue = endValue - 0.0001;
        }
    });

    // Black Gap Calculation between negative and positive ranges
    const blackGapStart = minValue;
    const blackGapEnd =
        (1 +
            config.find((band) => band.thresholdBandId === ThresholdBand.POS1)
                ?.value /
                100) *
            input.target -
        0.01;
    addThreshold('#000', blackGapStart, blackGapEnd);
    minValue = blackGapEnd + 0.0001;

    // Handle positive thresholds
    const posBands = [
        ThresholdBand.POS1,
        ThresholdBand.POS2,
        ThresholdBand.POS3,
    ];
    posBands.forEach((bandId, index) => {
        const bandConfig = config.find(
            (band) => band.thresholdBandId === bandId,
        );
        const nextBandConfig = config.find(
            (band) => band.thresholdBandId === posBands[index + 1],
        );

        if (bandConfig != null) {
            endValue =
                nextBandConfig != null
                    ? (1 + (nextBandConfig.value ?? 0) / 100) * input.target
                    : input.maxValueMetric;

            addThreshold(bandConfig.colour, minValue, endValue);
            minValue = endValue + 0.0001;
        }
    });

    return thresholds;
}
